import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import modalStates from 'constants/contractContents';
import Modal from './Modal';

const AcquiescenceModal = ({
  visible, setVisible, setAgreement,
}) => {
  const modalContentRef = useRef();

  useEffect(() => {
    if (visible) {
      modalContentRef.current.innerHTML = modalStates.acquiescence;
    }
  }, [visible]);

  if (!visible) {
    return null;
  }

  return (
    <Modal
      visible={visible}
      setVisible={setVisible}
    >
      <div className="modal-content d-inline-block">
        <div className="modal-header">
          <div className="modal-title">
            <div className="fs-44 fw-900">Ticari İletişim Rıza Metni</div>
          </div>
        </div>
        <div className="modal-body" ref={modalContentRef} />
        <div className="modal-footer modal-footer-sticky">
          <div className="row w-100">
            <div className="col-15 mb-3 mb-sm-0 col-sm">
              <a
                className="im-button im-button--center im-button--fluid im-button--outline-yellow2"
                onClick={() => {
                  setVisible(false);
                  setAgreement(false);
                }}
              >
                Kabul Etmiyorum
              </a>
            </div>
            <div className="col-15 col-sm">
              <a
                className="im-button im-button--center im-button--fluid im-button--primary"
                onClick={() => {
                  setVisible(false);
                  setAgreement(true);
                }}
              >
                Kabul Ediyorum
              </a>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

AcquiescenceModal.propTypes = {
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  setAgreement: PropTypes.func,
};

export default AcquiescenceModal;
